import { AxiosError } from 'axios';

import { selectExaminationQuestions, selectExampleQuestion, selectNextQuestion } from '../../_utils/questionHelpers';
import { Answer, Examination, Question } from '../_models';
import { ExaminationAction, ExaminationActionType } from './actions';

export type ExaminationState = {
  currentQuestion?: Question;
  data: Examination;
  error?: AxiosError;
  exampleQuestion?: Question;
  isLoading?: boolean;
  questions: Question[];
  result: Record<string, Answer>;
};

const initialState: ExaminationState = {
  currentQuestion: null,
  data: null,
  questions: [],
  result: null,
};

export default function reducer(state = initialState, action: ExaminationAction): ExaminationState {
  switch (action.type) {
    case ExaminationActionType.SelectNextQuestion:
      return {
        ...state,
        currentQuestion: selectNextQuestion(state.currentQuestion?.question_id, state.questions),
      };
    case ExaminationActionType.ShowNextResultQuestion: {
      const currentIndex = state.questions.indexOf(state.currentQuestion);
      return {
        ...state,
        currentQuestion: state.questions[currentIndex + 1],
      };
    }
    case ExaminationActionType.ShowPreviousResultQuestion: {
      const currentIndex = state.questions.indexOf(state.currentQuestion);
      return {
        ...state,
        currentQuestion: state.questions[currentIndex - 1],
      };
    }
    case ExaminationActionType.SetAnswer:
      return {
        ...state,
        result: { ...state.result, [action.payload.questionId]: action.payload.answer },
      };
    case ExaminationActionType.StartExampleQuestion: {
      const { questions, exampleQuestion } = selectExaminationQuestions(state.data.categories, state.data.questions);
      return {
        ...state,
        currentQuestion: exampleQuestion,
        exampleQuestion,
        questions,
        result: questions.reduce((acc, question) => ({ ...acc, [question.question_id]: null }), {}),
      };
    }
    case ExaminationActionType.FetchExamination: {
      return initialState;
    }
    case ExaminationActionType.FetchExaminationSuccess: {
      return {
        ...state,
        data: action.payload.examination,
        exampleQuestion: selectExampleQuestion(action.payload.examination.questions),
        isLoading: false,
      };
    }
    case ExaminationActionType.FetchExaminationError: {
      return {
        ...state,
        error: action.payload.error,
        isLoading: false,
      };
    }
    case ExaminationActionType.ShowResultQuestion:
      return {
        ...state,
        currentQuestion: action.payload.question,
      };
    case ExaminationActionType.StopExamination:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
